import { apiHost } from '../../../config';
import { post } from '../../requests';
import City from '../../../types/City';

export default async function createCity(city: Omit<City, 'id'>) {
  return post(`${apiHost}/api/admin/cities`, city);
}
